import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import useGradesTableStore from '../store/useGradesTableStore';

export const SUBMISSION_FIELDS = [
  'assignment_id',
  'graded_at',
  'id',
  'submitted_at',
  'total_score',
  'total_score_override',
  'user_id',
  'user_type',
  'in_progress',
  'normalized_total_score',
  'updated_since_graded',
  'first_submitted_at',
  'score_updated_at',
];
interface UseStudentSubmissionsOptions {
  forFilterData?: boolean;
}

const useStudentSubmissions = (options: UseStudentSubmissionsOptions = {}) => {
  const { forFilterData = false } = options;
  const stafferId = useGradesTableStore(state => state.stafferId);
  const programId = useGradesTableStore(state => state.programId);
  const assignments = useGradesTableStore(state => state.assignments);
  const students = useGradesTableStore(state => state.students);
  const setStore = useGradesTableStore(state => state.setStore);

  const fetchDataFields = SUBMISSION_FIELDS;
  // `graded_status` is a heavier computed backend field, so only fetch it if the user uses the filtering feature.
  if (forFilterData) fetchDataFields.push('graded_status');

  const query = useQuery(['Submissions', stafferId, programId, forFilterData ? 'filter' : 'main'], () => {
    const path = Routes.plato_api_submissions_path({
      for_assignments: assignments.map(a => a.id),
      for_student: students.map(s => s.id),
      only: fetchDataFields,
    });

    return axios.get(path)
      .then(res => res.data.data);
  }, { enabled: assignments.length > 0 && students.length > 0 });

  useEffect(() => {
    if (query.isError) {
      setStore({ isLoadingSubmissions: false });
      return;
    }
    if (query.isFetching || !query.data) return;

    setStore({ isLoadingSubmissions: false, submissions: query.data });
  }, [query.data, query.isError]);

  return query;
};

export default useStudentSubmissions;
